import { render, staticRenderFns } from "./PureSearch.vue?vue&type=template&id=0db44940&scoped=true"
import script from "./PureSearch.vue?vue&type=script&lang=ts"
export * from "./PureSearch.vue?vue&type=script&lang=ts"
import style0 from "./PureSearch.vue?vue&type=style&index=0&id=0db44940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db44940",
  null
  
)

export default component.exports